import {
  ActionIcon,
  Badge,
  Box,
  Button,
  ComboboxItem,
  Flex,
  Grid,
  Group,
  Input,
  Loader,
  LoadingOverlay,
  Menu,
  Select,
  SelectProps,
  Text,
  Title,
  Tooltip,
  rem,
} from "@mantine/core";
import {
  IconBrandBootstrap,
  IconBuildingStore,
  IconCalendar,
  IconCaretDown,
  IconCheck,
  IconEdit,
  IconEye,
  IconFileExport,
  IconFileUpload,
  IconLocationFilled,
  IconPlus,
  IconSearch,
  IconStarFilled,
  IconUsers,
} from "@tabler/icons-react";
import {
  MRT_ColumnDef,
  MRT_RowSelectionState,
  MantineReactTable,
  useMantineReactTable,
} from "mantine-react-table";
import * as React from "react";
import { useEffect, useState } from "react";
import { DatePickerInput } from "@mantine/dates";
import {
  _timerDelayClick,
  keySearchReceptionList,
  repositoryMdm,
} from "../../../_base/_const/_constVar";
import _breadcrumb from "../../../_base/component/_layout/_breadcrumb";
import { paginationBase } from "../../../_base/model/_base/BaseTable";
import { AvatarUtils } from "../../../common/ColorByName/AvatarUtils";
import {
  formatDateNotTimeZone,
  formatDateTransfer,
} from "../../../common/FormatDate/FormatDate";
import { _localization } from "../../../config/location";
import { green, teal } from "../../../const/variables";
import { MessageResponse } from "../../../model/MessageResponse";
import { TblDMExpense } from "../../../model/TblDMExpense";
import {
  getBranchSelectMdm,
  getTblDmProcessingMethodSelect,
  getTblDmSaleChanelSelect,
} from "../../../service/getSelectApi";
import CreateDataView from "./CreateDataView";
import EditDataView from "./EditDataView";
import { getValueById } from "../../../_base/helper/FunctionHelper";
import { BASE_API_MDM } from "../../../config";
import {
  useDebouncedState,
  useDisclosure,
  useIsFirstRender,
} from "@mantine/hooks";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { useNavigate } from "react-router-dom";

type ColumnPinningType = {
  left?: string[];
  right?: string[];
};

const ReceptionList = () => {
  //#region State
  //data and fetching state
  const navigate = useNavigate();
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [data, setData] = useState<TblDMExpense[]>([]);
  const [dataTemp, setDataTemp] = useState<TblDMExpense[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [height, setHeight] = useState(0);
  const [idEdit, setIdEdit] = useState(0);

  //table state
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});

  // const [keySearch, setKeySearch] = useState<string>("");
  const [selectIds, setSelectIds] = useState<string[]>([]);
  const [deleteViewStatus, setDeleteViewStatus] = useState(false);
  const [pagination, setPagination] = useState(paginationBase);
  const [visible, { toggle, open, close }] = useDisclosure(false);
  //count
  const [timeLeft, setTimeLeft] = useState(60);
  const [isCounting, setIsCounting] = useState(false);
  const [dataTblBranch, setDataTblBranch] = useState<ComboboxItem[]>([]);
  const [dataWarrantyCustomerGroup, setDataWarrantyCustomerGroup] = useState<
    ComboboxItem[]
  >([]);
  const [dataTblDmRequestStatus, setDataTblDmRequestStatus] = useState<{
    isLoad: boolean;
    data: any[];
  }>({
    isLoad: false,
    data: [
      { label: "Chờ phân công", value: "CHO_PHAN_CONG" },
      { label: "Đã phân công", value: "DA_PHAN_CONG" },
      { label: "Hủy phân công", value: "HUY_PHAN_CONG" },
      { label: "Đang xử lý", value: "DANG_XU_LY" },
      { label: "Đã xử lý", value: "DA_XU_LY" },
      { label: "Hãng xử lý", value: "HANG_XU_LY" },
      { label: "Hãng đang xử lý", value: "HANG_DANG_XU_LY" },
      { label: "Hãng đã xử lý", value: "HANG_DA_XU_LY" },
      { label: "Xử lý lại", value: "XU_LY_LAI" },
      { label: "Trả khách", value: "TRA_KHACH" },
    ],
  });

  const [dataTblProcessingMethod, setDataTblProcessingMethod] = useState<{
    isLoad: boolean;
    data: any[];
  }>({
    isLoad: false,
    data: [],
  });

  const [dataTblSaleChannel, setDataTblSaleChannel] = useState<{
    isLoad: boolean;
    data: any[];
  }>({
    isLoad: false,
    data: [],
  });

  // Search
  const firstRender = useIsFirstRender();
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") === "true";
  const _searchJson = (() => {
    try {
      const storedValue = sessionStorage.getItem(keySearchReceptionList);
      return storedValue ? JSON.parse(storedValue) : null;
    } catch (error) {
      console.error("Lỗi khi parse JSON từ sessionStorage:", error);
      return null;
    }
  })();

  const [search, setSearch] = useState({
    startDate:
      firstRender && _searchJson && checkedPinSearch
        ? _searchJson.startDate
        : new Date(
            new Date(new Date().setMonth(new Date().getMonth() - 1)).getTime() +
              7 * 60 * 60 * 1000,
          )?.toISOString(),
    endDate:
      firstRender && _searchJson && checkedPinSearch
        ? _searchJson.endDate
        : new Date(
            new Date(
              new Date(new Date().setDate(new Date().getDate() + 1)).setHours(
                0,
                0,
                0,
                0,
              ),
            ).getTime() +
              7 * 60 * 60 * 1000,
          )?.toISOString(),
    status:
      firstRender && _searchJson && checkedPinSearch ? _searchJson.status : "",
    processingMethod:
      firstRender && _searchJson && checkedPinSearch
        ? _searchJson.processingMethod
        : "",
    channel:
      firstRender && _searchJson && checkedPinSearch ? _searchJson.channel : "",
    customerGroup:
      firstRender && _searchJson && checkedPinSearch
        ? _searchJson.customerGroup
        : "",
    branch:
      firstRender && _searchJson && checkedPinSearch ? _searchJson.branch : "",
  });

  const [keySearch, setKeySearch] = useDebouncedState<string>(
    firstRender && _searchJson && checkedPinSearch ? _searchJson.keySearch : "",
    300,
  );

  //viewState
  const [actionView, setActionView] = useState("");

  //#region  table
  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "createDate",
        header: "Ngày tiếp nhận",
        Cell: ({ renderedCellValue }: any) => (
          <Text size="12.5px" fw={"500"}>
            {renderedCellValue && formatDateTransfer(renderedCellValue)}
          </Text>
        ),
        enableSorting: false,
        enableColumnFilter: false,
        enableColumnActions: true,
      },
      {
        accessorKey: "requestNum",
        header: "Mã phiếu tiếp nhận yêu cầu",
        Cell: ({ renderedCellValue, row }) => (
          <Tooltip label="Xem chi tiết">
            <Badge
              radius="sm"
              variant="dot"
              size="lg"
              style={{ cursor: "pointer" }}
              color={renderedCellValue === null ? "red" : green.base}
              onDoubleClick={() => detailItem(row.original.id)}
            >
              {renderedCellValue === null ? null : renderedCellValue}
            </Badge>
          </Tooltip>
        ),
        enableSorting: false,
        enableColumnActions: true,
        enableColumnFilter: false,
        size: 225,
      },
      {
        accessorKey: "attribute10",
        header: "Số phiếu tiếp nhận yêu cầu",
        Cell: ({ renderedCellValue, row }) => (
          <Badge
            radius="sm"
            variant="dot"
            size="lg"
            color={renderedCellValue === null ? "red" : green.base}
          >
            {renderedCellValue === null
              ? "Không có số phiếu"
              : renderedCellValue}
          </Badge>
        ),
        size: 200,
        enableSorting: false,
        enableColumnActions: true,
        enableColumnFilter: false,
      },
      {
        accessorKey: "createByName",
        header: "Người tiếp nhận",
        Cell: ({ row }: any) => (
          <AvatarUtils value={row.original.createByName} />
        ),
        enableSorting: false,
        enableColumnActions: true,
        enableColumnFilter: false,
        size: 225,
      },
      {
        accessorKey: "channelName",
        header: "Kênh",
        Cell: ({ renderedCellValue }: any) => (
          <Text size="12.5px" fw={"500"}>
            {renderedCellValue}
          </Text>
        ),
        enableSorting: false,
        enableColumnActions: true,
        enableColumnFilter: false,
        size: 225,
      },
      {
        accessorKey: "customerGroupName",
        header: "Nhóm khách hàng",
        enableSorting: false,
        enableColumnActions: true,
        enableColumnFilter: false,
      },
      {
        accessorKey: "processingMethodName",
        header: "Hình thức xử lý",
        Cell: ({ renderedCellValue, row }) => (
          <Badge
            color={getColorProcessingMethod(row.original?.processingMethodName)}
          >
            {renderedCellValue}
          </Badge>
        ),
        enableSorting: false,
        enableColumnActions: true,
        enableColumnFilter: false,
      },
      {
        accessorKey: "meetingAddress",
        header: "Địa chỉ",
        Cell: ({ renderedCellValue, row }: any) => (
          <Text fw={"500"} size="12.5px">
            {row.original.additionalAddress !== null
              ? `${row.original.additionalAddress} - ${renderedCellValue}`
                  .replace(/\s*-\s*-\s*/g, " - ")
                  .replace(/^\s*-\s*/, "")
              : `${renderedCellValue}`.replace(/^\s*-\s*/, "")}{" "}
          </Text>
        ),
        enableSorting: false,
        enableColumnActions: true,
        enableColumnFilter: false,
        size: 550,
      },
      {
        accessorKey: "requestStatus",
        header: "Trạng thái",
        Cell: ({ row }) => (
          <>
            <Badge
              radius={"sm"}
              color={getColorStatus(row.original.requestStatus?.toString())}
              variant="light"
              bd={`1px solid ${getColorStatus(
                row.original.requestStatus?.toString(),
              )}`}
            >
              {getValueStatus(row.original.requestStatus) ?? "Không xác định"}
            </Badge>
          </>
        ),
        enableSorting: false,
        enableColumnActions: true,
        enableColumnFilter: false,
      },
      {
        accessorKey: "branchId",
        header: "Nơi nhận yêu cầu",
        Cell: ({ row }: any) => (
          <Text size="12.5px" variant="light" fw={"700"}>
            {getValueById(
              row.original.branchId?.toString() ?? "",
              dataTblBranch,
              "label",
            )}
          </Text>
        ),
        enableSorting: false,
        enableColumnActions: true,
        enableColumnFilter: false,
      },
      {
        accessorKey: "content",
        header: "Nội dung",
        enableSorting: false,
        enableColumnActions: true,
        enableColumnFilter: false,
      },
      {
        accessorKey: "action",
        header: "Thao tác",
        enableResizing: false,
        enableSorting: false,
        size: 85,
        enableColumnActions: true,
        enableColumnFilter: false,
        Cell: ({ row }) => (
          <Box
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <Tooltip label="Chỉnh sửa">
              <ActionIcon
                variant="light"
                aria-label="Settings"
                color="orange"
                onClick={() => {
                  editItem(row.original.id);
                }}
                disabled={
                  row.original.requestStatus !== "CHO_PHAN_CONG" &&
                  row.original.requestStatus !== "DA_PHAN_CONG" &&
                  row.original.requestStatus !== "HANG_XU_LY"
                }
              >
                <IconEdit size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>
            <Tooltip label="Xem chi tiết">
              <ActionIcon
                variant="light"
                aria-label="Settings"
                color="blue"
                onClick={() => detailItem(row.original.id)}
              >
                <IconEye size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>
          </Box>
        ),
      },
    ],
    [dataTblBranch],
  );

  function getColorStatus(status: string) {
    switch (status) {
      case "DA_PHAN_CONG":
      case "DA_XU_LY":
      case "HANG_DA_XU_LY":
      case "TRA_KHACH":
        return "#4CAF50";

      case "CHO_PHAN_CONG":
      case "XU_LY_LAI":
      case "HANG_DANG_XU_LY":
      case "CHUA_XU_LY":
        return "#d9d02f";

      case "HUY_PHAN_CONG":
      case "KY_THUAT_HUY":
        return "#F44336";

      case "HANG_XU_LY":
        return "#2196F3";

      case "DANG_XU_LY":
        return "#FF9800";

      case "":
      case null:
        return "rgba(255, 255, 255, 0)";

      default:
        return "#424242";
    }
  }

  function getValueStatus(value: string) {
    switch (value) {
      case "CHO_PHAN_CONG":
        return "Chờ phân công";
      case "HUY_PHAN_CONG":
        return "Hủy phân công";
      case "DA_PHAN_CONG":
        return "Đã phân công";
      case "XU_LY_LAI":
        return "Xử lý lại";
      case "KY_THUAT_HUY":
        return "Kỹ thuật hủy";
      case "HANG_XU_LY":
        return "Hãng xử lý";
      case "HANG_DANG_XU_LY":
        return "Hãng đang xử lý";
      case "DANG_XU_LY":
        return "Đang xử lý";
      case "DA_XU_LY":
        return "Đã xử lý";
      case "TRA_KHACH":
        return "Trả khách";
    }
  }

  function getColorProcessingMethod(value: string) {
    switch (value) {
      case "Xử lý tại nhà":
        return "lime";
      case "Hãng xử lý":
        return "green";
      case "Xử ý trực tiếp":
        return "teal";
      case "Xử lý tại CH/CN":
        return "cyan";
      case "Xử lý từ xa":
        return "orange";
    }
  }

  const startCountdown = () => {
    if (!isCounting) {
      setTimeLeft(_timerDelayClick);
      setIsCounting(true);
    }
  };

  const dataBranchSelect = async () => {
    const getData = await getBranchSelectMdm();
    setDataTblBranch(
      getData
        ?.filter(
          (item) =>
            item.value != null && item.text != null && item.value != "-1",
        )
        ?.map((item) => ({
          value: item.value,
          label: item.text,
        })),
    );
  };

  const getDataWarrantyCustomerGroup = async () => {
    const res = await repositoryMdm.get<MessageResponse<any>>(
      "/api/v1/TblWarrantyCustomerGroup/get-all",
    );

    if (res && res?.success) {
      const getData = res.data;
      const filteredData = getData?.filter(
        (item: any) => item.text != null && item.value != null,
      );
      const mappedData = filteredData?.map((item: any) => ({
        value: item.value?.toString(),
        label: item.text,
      }));
      setDataWarrantyCustomerGroup(mappedData);
    }
  };

  const saleChannelSelect = async () => {
    try {
      const getData = await getTblDmSaleChanelSelect();
      const filteredData = getData?.filter(
        (item) => item.value != null && item.text != null,
      );
      const mappedData = filteredData?.map((item) => ({
        value: item.value?.toString(),
        label: item.text?.toString(),
      }));
      setDataTblSaleChannel((prev) => ({
        ...prev,
        data: mappedData,
      }));
    } catch (error) {
      console.error("Error in dataTblLocation: ", error);
    }
  };

  const dataProcessingMethodSelect = async () => {
    try {
      const getData = await getTblDmProcessingMethodSelect();
      const filteredData = getData?.filter(
        (item) => item.value != null && item.text != null,
      );
      const mappedData = filteredData?.map((item) => ({
        value: item.value,
        label: item.text,
      }));
      setDataTblProcessingMethod((prev) => ({
        ...prev,
        data: mappedData,
      }));
    } catch (error) {
      console.error("Error in dataTblLocation: ", error);
    }
  };

  const handleChangeSearchValue = (value: string, key: string) => {
    setSearch((prevData) => ({ ...prevData, [key]: value }));
  };

  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);

    let url = `?Skip=${pagination?.pageIndex * pagination?.pageSize}&Take=${
      pagination.pageSize
    }`;

    if (search.startDate) {
      url += `&StartDate=${search.startDate}`;
    }

    if (search.endDate) {
      url += `&EndDate=${search.endDate}`;
    }

    if (keySearch) {
      url += `&KeySearch=${keySearch.trim()}`;
    }

    if (search.status) {
      url += `&RequestStatus=${search.status}`;
    }

    if (search.channel) {
      url += `&Channel=${search.channel}`;
    }

    if (search.processingMethod) {
      url += `&ProcessingMethod=${search.processingMethod}`;
    }

    if (search.customerGroup) {
      url += `&CustomerGroup=${search.customerGroup}`;
    }

    if (search.branch) {
      url += `&BranchId=${search.branch}`;
    }

    try {
      const response = await repositoryMdm.get(
        `/api/v1/TblWarrantyServiceRequestForm/get-list-v2${url}`,
      );
      if (response && response.success) {
        let result = response.data;
        await Promise.all([dataBranchSelect()]);
        setData(result);
        setDataTemp(result);
        setRowCount(response.totalCount ?? 0);
        setSelectIds([]);
        table.resetRowSelection();
      }
    } catch (error) {
      setData([]);
      setIsError(true);
      console.error(error);
      return;
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
      sessionStorage.setItem(
        keySearchReceptionList,
        JSON.stringify({
          ...search,
          keySearch: keySearch,
        }),
      );
    }
    startCountdown();
  };

  const handleExport = async () => {
    open();
    try {
      let url = `/api/v1/TblWarrantyServiceRequestForm/export-tbl-warranty-service-request-form?Skip=${
        pagination?.pageIndex * pagination?.pageSize
      }&Take=${pagination.pageSize}`;

      if (search.startDate) {
        url += `&StartDate=${search.startDate}`;
      }

      if (search.endDate) {
        url += `&EndDate=${search.endDate}`;
      }

      if (keySearch) {
        url += `&KeySearch=${keySearch.trim()}`;
      }

      if (search.status) {
        url += `&RequestStatus=${search.status}`;
      }

      if (search.channel) {
        url += `&Channel=${search.channel}`;
      }

      if (search.processingMethod) {
        url += `&ProcessingMethod=${search.processingMethod}`;
      }

      if (search.customerGroup) {
        url += `&CustomerGroup=${search.customerGroup}`;
      }

      if (search.branch) {
        url += `&BranchId=${search.branch}`;
      }

      const _url = BASE_API_MDM + url;
      const token = localStorage.getItem("token");

      const response = await fetch(_url, {
        method: "GET",
        headers: {
          "Content-Type": "application/vnd.ms-excel",
          Authorization: `Bearer ${token?.replace(`"`, "").replace(`"`, "")}`,
        },
      });

      if (!response.ok) {
        NotificationExtension.Fails("Export Excel thất bại !");
      } else {
        const blob = await response.blob();
        const urlss = window.URL.createObjectURL(blob);
        const _name = new Date().toISOString().slice(0, 10);
        let filename = "danh_sach_phieu_yeu_cau_xu_ly" + _name + ".xlsx";
        const link = document.createElement("a");
        link.href = urlss;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        NotificationExtension.Success("Export Excel thành công !");
      }
    } catch (error) {
      console.log(error);
    } finally {
      close();
    }
  };

  const ActionViews = React.useCallback(() => {
    switch (actionView) {
      case "CREATE":
        return (
          <Box h={window.innerHeight - 180}>
            <CreateDataView
              onClose={setActionView}
              onSuccess={setDeleteViewStatus}
            />
          </Box>
        );
      case "EDIT":
        return (
          <Box h={window.innerHeight - 180}>
            <EditDataView
              id={idEdit}
              onClose={setActionView}
              onSuccess={setDeleteViewStatus}
            />
          </Box>
        );
      default:
        return null;
    }
  }, [actionView]);

  const createItem = React.useCallback(() => {
    setActionView("CREATE");
  }, []);

  const editItem = React.useCallback((id: string | number) => {
    setActionView("EDIT");
    setIdEdit(Number(id));
  }, []);

  const detailItem = React.useCallback(
    (id: string | number) => {
      navigate("/warranty/detail-receive-warranty", {
        state: { id: Number(id) },
      });
    },
    [navigate],
  );

  const optionColorsAccount: Record<
    | "Xử lý tại nhà"
    | "Hãng xử lý"
    | "Xử lý tại chỗ"
    | "Xử lý tại CH/CN"
    | "Xử lý từ xa",
    string
  > = {
    "Xử lý tại nhà": "lime",
    "Hãng xử lý": "green",
    "Xử lý tại chỗ": "teal",
    "Xử lý tại CH/CN": "cyan",
    "Xử lý từ xa": "orange",
  };

  const renderSelectOptionStatus: SelectProps["renderOption"] = ({
    option,
    checked,
  }) => (
    <Group flex="1" gap="xs">
      <Badge
        color={
          optionColorsAccount[
            option.label as
              | "Xử lý tại nhà"
              | "Hãng xử lý"
              | "Xử lý tại chỗ"
              | "Xử lý tại CH/CN"
              | "Xử lý từ xa"
          ]
        }
        radius="sm"
        variant="filled"
      >
        {option.label}
      </Badge>
      {checked && (
        <IconCheck size={"14px"} style={{ marginInlineStart: "auto" }} />
      )}
    </Group>
  );

  useEffect(() => {
    let timer: ReturnType<typeof setInterval>;
    if (isCounting && timeLeft > 0) {
      timer = setInterval(() => {
        setTimeLeft((prevTime) => prevTime - 1);
      }, 1000);
    } else if (timeLeft === 0) {
      setIsCounting(false);
    }
    return () => clearInterval(timer);
  }, [isCounting, timeLeft]);

  useEffect(() => {
    const valuesList = Object.keys(rowSelection);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
    else {
      const valuesList = Object.keys(rowSelection);
      setSelectIds(valuesList);
    }
  }, [rowSelection]);

  useEffect(() => {
    fetchData();
  }, [pagination, deleteViewStatus]);

  // useEffect(() => {
  //   if (
  //     dataTblDmRequestStatus.isLoad &&
  //     dataTblDmRequestStatus.data?.length === 0
  //   )
  //     dataRequestStatusSelect();
  // }, [dataTblDmRequestStatus.isLoad]);

  useEffect(() => {
    dataProcessingMethodSelect();
    saleChannelSelect();
    getDataWarrantyCustomerGroup();
  }, []);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      // 160 là chiều cao của phần phân trang
      // headerHeight là chiều cao của phần header
      setHeight(window.innerHeight - (140 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize); // Update height on window resize

    return () => {
      window.removeEventListener("resize", handleResize); // Clean up event listener
    };
  }, [height]);

  const getColumnPinningStorage = () => {
    const columnPinningStorage = localStorage.getItem(
      "columnPinningReceptionList",
    );
    return columnPinningStorage
      ? JSON.parse(columnPinningStorage)
      : {
          left: ["mrt-row-select", "requestNum"],
          right: ["attribute10", "action"],
        }; // Giá trị mặc định
  };

  // Lưu columnPinning vào state
  const [columnPinning, setColumnPinning] = useState<ColumnPinningType>(
    getColumnPinningStorage(),
  );

  // Hàm lưu vào localStorage
  useEffect(() => {
    localStorage.setItem(
      "columnPinningReceptionList",
      JSON.stringify(columnPinning),
    );
  }, [columnPinning]);

  const table = useMantineReactTable({
    columns,
    data,
    enableColumnResizing: true,

    positionToolbarAlertBanner: "bottom",
    //add custom action buttons to top-left of top toolbar
    enableTopToolbar: false,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },

    localization: _localization,
    enableRowSelection: true,
    getRowId: (row) => row.id,
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        ...columnPinning,
      },
      columnVisibility: { id: false },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    onColumnPinningChange: (newState) => {
      setColumnPinning(newState);
    },
    onRowSelectionChange: setRowSelection,
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    rowCount,
    // onColumnFiltersChange: setColumnFilters,
    // onGlobalFilterChange: setGlobalFilter,
    onPaginationChange: setPagination,
    // onSortingChange: setSorting,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        //  fontWeight: row.getIsSelected() ? "bold" : "normal", //conditional styling
        fontWeight: "500", //conditional styling
        fontSize: "12.5px",
        padding: "5px 15px",
      },
    }),
    state: {
      // columnFilters,
      // globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading, //loading for the first time with no data
      //sorting,
      rowSelection,
      columnPinning,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["25", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    columnFilterDisplayMode: "popover",
    mantineTableBodyRowProps: ({ row }) => ({
      onClick: row.getToggleSelectedHandler(),
      onDoubleClick: () => {
        detailItem(row?.original?.id);
      },
      sx: { cursor: "pointer" },
    }),
  });
  //#endregion
  return (
    <>
      {(!actionView.isNullOrEmpty() && <ActionViews />) || (
        <>
          <div
            ref={headerRef}
            style={{
              width: "100%",
              border: "1px solid #dee2e6",
              padding: "10px",
            }}
          >
            <LoadingOverlay
              visible={visible}
              zIndex={1000}
              overlayProps={{ radius: "sm", blur: 5 }}
              loaderProps={{
                children: (
                  <Flex direction={"column"} align="center" gap="xs">
                    <Loader type="dots" size={35}></Loader>
                    {/* <Title size={15}> Đang upload tài liệu...</Title> */}
                    <Title size={15}> Đang xử lý....</Title>
                  </Flex>
                ),
              }}
            />
            <Flex
              w={"100%"}
              align={"center"}
              justify={"space-between"}
              direction="row"
              wrap="wrap"
              mb={"sm"}
            >
              <_breadcrumb></_breadcrumb>
              <Flex
                gap="md"
                justify="flex-end"
                align="center"
                direction="row"
                wrap="wrap"
              >
                <Button
                  leftSection={<IconPlus size={14} />}
                  color="blue"
                  variant="outline"
                  onClick={async () => {
                    createItem();
                  }}
                >
                  Thêm mới
                </Button>
                <Menu shadow="md" width={200}>
                  <Menu.Target>
                    <Button
                      // size="xs"
                      rightSection={
                        <IconCaretDown
                          style={{ width: rem(14), height: rem(14) }}
                        />
                      }
                    >
                      Chức năng
                    </Button>
                  </Menu.Target>

                  <Menu.Dropdown>
                    <Menu.Item
                      leftSection={
                        <IconFileExport
                          style={{ width: rem(14), height: rem(14) }}
                        />
                      }
                      onClick={() => handleExport()}
                    >
                      Export Excel
                    </Menu.Item>
                    <Tooltip label={"Chức năng đang update"}>
                      <Menu.Item
                        leftSection={
                          <IconFileUpload
                            style={{ width: rem(14), height: rem(14) }}
                          />
                        }
                      >
                        Import Excel
                      </Menu.Item>
                    </Tooltip>
                  </Menu.Dropdown>
                </Menu>
              </Flex>
            </Flex>
            <Grid w={"100%"}>
              <Grid.Col span={{ base: 12, md: 4, lg: 2.4 }}>
                <DatePickerInput
                  size="sm"
                  placeholder="Từ ngày"
                  leftSection={<IconCalendar color="#15aabf" />}
                  locale="vi"
                  valueFormat="DD/MM/YYYY"
                  value={
                    search.startDate && search.startDate.length > 0
                      ? new Date(search.startDate)
                      : null
                  }
                  maxDate={
                    search.endDate && search.endDate?.length > 0
                      ? new Date(search.endDate)
                      : new Date()
                  }
                  onChange={(e) => {
                    handleChangeSearchValue(
                      formatDateNotTimeZone(e) ?? "",
                      "startDate",
                    );
                  }}
                  clearable
                />
              </Grid.Col>
              <Grid.Col span={{ base: 12, md: 4, lg: 2.4 }}>
                <DatePickerInput
                  size="sm"
                  placeholder="Đến ngày"
                  leftSection={<IconCalendar color="#15aabf" />}
                  locale="vi"
                  valueFormat="DD/MM/YYYY"
                  value={
                    search.endDate && search.endDate.length > 0
                      ? new Date(search.endDate)
                      : null
                  }
                  minDate={
                    search.startDate && search.startDate?.length > 0
                      ? new Date(search.startDate)
                      : undefined
                  }
                  onChange={(e) => {
                    handleChangeSearchValue(
                      formatDateNotTimeZone(e) ?? "",
                      "endDate",
                    );
                  }}
                  clearable
                />
              </Grid.Col>
              <Grid.Col span={{ base: 12, md: 4, lg: 2.4 }}>
                <Select
                  placeholder="Chi nhánh"
                  searchable
                  clearable
                  value={search.branch || null}
                  data={dataTblBranch}
                  leftSection={
                    <IconBrandBootstrap
                      size={20}
                      style={{ color: teal.base }}
                    />
                  }
                  onChange={(e) =>
                    handleChangeSearchValue(e?.toString() ?? "", "branch")
                  }
                />
              </Grid.Col>
              <Grid.Col span={{ base: 12, md: 4, lg: 2.4 }}>
                <Select
                  placeholder="Trạng thái"
                  searchable
                  clearable
                  value={search.status || null}
                  comboboxProps={{
                    transitionProps: { transition: "pop", duration: 200 },
                  }}
                  leftSection={
                    <IconStarFilled
                      size={20}
                      style={{ color: teal.base }}
                    ></IconStarFilled>
                  }
                  w={"100%"}
                  data={dataTblDmRequestStatus.data}
                  onClick={() =>
                    setDataTblDmRequestStatus((prev) => ({
                      ...prev,
                      isLoad: true,
                    }))
                  }
                  onChange={(e) => {
                    handleChangeSearchValue(e?.toString() ?? "", "status");
                  }}
                />
              </Grid.Col>
              <Grid.Col span={{ base: 12, md: 4, lg: 2.4 }}>
                <Select
                  placeholder="Hình thức xử lý"
                  type="text"
                  w={"100%"}
                  clearable
                  searchable
                  value={search.processingMethod || null}
                  leftSection={
                    <IconLocationFilled
                      size={20}
                      style={{ color: teal.base }}
                    ></IconLocationFilled>
                  }
                  comboboxProps={{
                    transitionProps: { transition: "pop", duration: 200 },
                  }}
                  data={dataTblProcessingMethod.data}
                  onChange={(e) => {
                    handleChangeSearchValue(
                      e?.toString() ?? "",
                      "processingMethod",
                    );
                  }}
                  renderOption={renderSelectOptionStatus}
                />
              </Grid.Col>
            </Grid>
            <Grid>
              <Grid.Col span={{ base: 12, md: 4, lg: 2.4 }}>
                <Select
                  placeholder="Kênh"
                  type="text"
                  w={"100%"}
                  clearable
                  searchable
                  value={search.channel || null}
                  leftSection={
                    <IconBuildingStore
                      size={20}
                      style={{ color: teal.base }}
                    ></IconBuildingStore>
                  }
                  comboboxProps={{
                    transitionProps: { transition: "pop", duration: 200 },
                  }}
                  data={dataTblSaleChannel.data}
                  onChange={(e) => {
                    handleChangeSearchValue(e?.toString() ?? "", "channel");
                  }}
                />
              </Grid.Col>
              <Grid.Col span={{ base: 12, md: 4, lg: 2.4 }}>
                <Select
                  placeholder="Nhóm khách hàng"
                  data={dataWarrantyCustomerGroup}
                  searchable
                  clearable
                  value={search.customerGroup || null}
                  leftSection={
                    <IconUsers size={20} style={{ color: teal.base }} />
                  }
                  onChange={(e) => {
                    handleChangeSearchValue(
                      e?.toString() ?? "",
                      "customerGroup",
                    );
                  }}
                  nothingFoundMessage="Không tìm thấy dữ liệu !"
                />
              </Grid.Col>
              <Grid.Col span={{ base: 12, md: 4, lg: 2.4 }}>
                <Input
                  placeholder="Nhập từ khóa tìm kiếm"
                  type="text"
                  w={"100%"}
                  defaultValue={keySearch}
                  leftSection={
                    <IconSearch
                      size={20}
                      style={{ color: teal.base }}
                    ></IconSearch>
                  }
                  onChange={(e) => {
                    setKeySearch(e.currentTarget.value);
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      fetchData();
                    }
                  }}
                />
              </Grid.Col>
              <Grid.Col span={{ base: 12, md: 4, lg: 2.4 }}>
                <Button
                  leftSection={<IconSearch size={14} />}
                  color="blue"
                  variant="outline"
                  onClick={async () => {
                    await fetchData();
                  }}
                >
                  Tìm kiếm
                </Button>
              </Grid.Col>
            </Grid>
          </div>
          <div>
            <MantineReactTable table={table} />
          </div>
        </>
      )}
    </>
  );
};
export default ReceptionList;
